import { z } from 'zod';
export const importDedupeMode = z.enum(['skip', 'overwrite', 'merge']);
export const importTargetEntity = z.enum(['workers', 'projects', 'customers', 'contacts', 'suppliers', 'training']);
export const importAgencyDecision = z.object({
    action: z.enum(['link', 'create', 'skip']),
    code: z.string().optional(),
});
// Customer type is a closed enum, so the only resolutions are "use this enum
// value" or "leave as Other". No "create new" option.
export const importEnumDecision = z.object({
    action: z.enum(['link', 'fallback']),
    code: z.string().optional(),
});
export const runImportSchema = z.object({
    entity: importTargetEntity,
    mode: importDedupeMode,
    columnMap: z.record(z.string()),
    rows: z.array(z.record(z.any())),
    agencyDecisions: z.record(importAgencyDecision).optional(),
    customerTypeDecisions: z.record(importEnumDecision).optional(),
});
export const preflightImportSchema = z.object({
    entity: importTargetEntity,
    columnMap: z.record(z.string()),
    rows: z.array(z.record(z.any())),
});
//# sourceMappingURL=import.js.map